__turbopack_context__.v({
  "alloysLoremIpsum": "resource-list-grid-module__egowta__alloysLoremIpsum",
  "beyondTheBasics": "resource-list-grid-module__egowta__beyondTheBasics",
  "blogGrid": "resource-list-grid-module__egowta__blogGrid",
  "blogGridContainer": "resource-list-grid-module__egowta__blogGridContainer",
  "blogGridEyebrow": "resource-list-grid-module__egowta__blogGridEyebrow",
  "blogGridHeading": "resource-list-grid-module__egowta__blogGridHeading",
  "blogGridTitle": "resource-list-grid-module__egowta__blogGridTitle",
  "button": "resource-list-grid-module__egowta__button",
  "cards": "resource-list-grid-module__egowta__cards",
  "caseStudyGrid": "resource-list-grid-module__egowta__caseStudyGrid",
  "chevronLeftLarge": "resource-list-grid-module__egowta__chevronLeftLarge",
  "chevronRightLarge": "resource-list-grid-module__egowta__chevronRightLarge",
  "chevronRightSmall": "resource-list-grid-module__egowta__chevronRightSmall",
  "container": "resource-list-grid-module__egowta__container",
  "content": "resource-list-grid-module__egowta__content",
  "contentGroup": "resource-list-grid-module__egowta__contentGroup",
  "dieCastingResources": "resource-list-grid-module__egowta__dieCastingResources",
  "dots": "resource-list-grid-module__egowta__dots",
  "eyeBrow": "resource-list-grid-module__egowta__eyeBrow",
  "grid": "resource-list-grid-module__egowta__grid",
  "navigation": "resource-list-grid-module__egowta__navigation",
  "navigationWrapper": "resource-list-grid-module__egowta__navigationWrapper",
  "nextButton": "resource-list-grid-module__egowta__nextButton",
  "overviewGrid": "resource-list-grid-module__egowta__overviewGrid",
  "pagination": "resource-list-grid-module__egowta__pagination",
  "paginationButton": "resource-list-grid-module__egowta__paginationButton",
  "paginationButton1": "resource-list-grid-module__egowta__paginationButton1",
  "paginationDotIcon": "resource-list-grid-module__egowta__paginationDotIcon",
  "paginationDotIcon1": "resource-list-grid-module__egowta__paginationDotIcon1",
  "paginationDotIcon2": "resource-list-grid-module__egowta__paginationDotIcon2",
  "paginationDotIcon3": "resource-list-grid-module__egowta__paginationDotIcon3",
  "paginationWrapper": "resource-list-grid-module__egowta__paginationWrapper",
  "prevButton": "resource-list-grid-module__egowta__prevButton",
  "resourceCarouselTitle": "resource-list-grid-module__egowta__resourceCarouselTitle",
  "resourceGrid": "resource-list-grid-module__egowta__resourceGrid",
  "resourceGridContainer": "resource-list-grid-module__egowta__resourceGridContainer",
  "resourceGridTitle": "resource-list-grid-module__egowta__resourceGridTitle",
  "sentencesAboutCompany": "resource-list-grid-module__egowta__sentencesAboutCompany",
  "slide": "resource-list-grid-module__egowta__slide",
  "title": "resource-list-grid-module__egowta__title",
  "viewAll": "resource-list-grid-module__egowta__viewAll",
});
